import {CmdCenterShowNearestModel} from "../../models/cmd/CmdCenterShowNearestModel";

export class CmdCenterShowNearestCtrl {
    public static $inject = ['$scope','$uibModalInstance','CmdCenterShowNearestModel','vtagId'];
    gridOptions:any;
    constructor(public $scope:any, public modalInstance:angular.ui.bootstrap.IModalServiceInstance,
                public model:CmdCenterShowNearestModel,
                vtagId:string) {
        $scope.vm= this;
        this.gridOptions = {
            columnDefs:[],
            data:[]
        };
        this.model.init(vtagId).then(()=>{
            this.gridOptions.columnDefs = this.getColumns();
            this.gridOptions.data = this.model.assets;
        });
    }

    Ok(){
        this.modalInstance.dismiss('cancel');
    }
    getColumns():any{
        var cols:any = [];
        $.each(this.model.assetColumnDefs, (index,nv)=>{
            cols.push({ field: nv[0], name:nv[1], width:nv[2], enableSorting:true, sort:null });
        })
        return cols;
    }
}
